import { gql } from "@apollo/client";

export const REGISTER_WITH_OTP = gql`
    mutation Signup($email: String!, $password: String!, $name: String!, $devOtp: String) {
        signup(email: $email, password: $password, name: $name, devOTP: $devOtp) {
            authToken
            email
            id
        }
    }
`;
